"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ErrorBoundaryFallback = function ErrorBoundaryFallback(_ref) {
  var buttonLabel = _ref.buttonLabel,
      customErrorImage = _ref.customErrorImage,
      descriptionErrorMessage = _ref.descriptionErrorMessage,
      _ref$hideButton = _ref.hideButton,
      hideButton = _ref$hideButton === void 0 ? false : _ref$hideButton,
      onClickButton = _ref.onClickButton,
      titleErrorMessage = _ref.titleErrorMessage;
  var onClick = (0, _react.useCallback)(function () {
    onClickButton ? onClickButton() : window.location.reload();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_antd.Col, {
    justify: "center",
    align: "middle",
    className: "errorBoundaryFallback"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "center",
    align: "middle",
    className: "errorBoundaryFallback__image"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: customErrorImage,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "center",
    align: "middle",
    className: "errorBoundaryFallback__title"
  }, /*#__PURE__*/_react.default.createElement("h1", null, titleErrorMessage)), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "center",
    align: "middle",
    className: "errorBoundaryFallback__description"
  }, /*#__PURE__*/_react.default.createElement("h2", null, descriptionErrorMessage)), !hideButton && /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "center",
    align: "middle",
    className: "errorBoundaryFallback__button"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: onClick
  }, buttonLabel)));
};

ErrorBoundaryFallback.propTypes = {
  buttonLabel: _propTypes.default.string.isRequired,
  customErrorImage: _propTypes.default.string.isRequired,
  descriptionErrorMessage: _propTypes.default.string.isRequired,
  hideButton: _propTypes.default.bool,
  onClickButton: _propTypes.default.func,
  titleErrorMessage: _propTypes.default.string.isRequired
};
var _default = ErrorBoundaryFallback;
exports.default = _default;